<nz-row [nzJustify]="'center'">
  <nz-col
    [nzLg]="{ span: 12, offset: 0 }"
    [nzMd]="{ span: 18, offset: 0 }"
    [nzSm]="{ span: 22, offset: 0 }"
    [nzXs]="{ span: 22, offset: 0 }">
    <article nz-typography>
      <h1 i18n="@@page-privacy-policy-content-title" nz-typography>
        Privacy Policy for Ig4u
      </h1>
      <p
        [nzType]="'secondary'"
        i18n="@@page-privacy-policy-content-paragraph-0"
        nz-typography>
        Effective Date: 2024-08-02
      </p>
      <p i18n="@@page-privacy-policy-content-paragraph-1" nz-typography>
        <strong>Thank you for choosing Ig4u!</strong> This Privacy Policy
        explains how we collect, use, and protect your information when you use
        our service located at <a [routerLink]="'/'">ig4u.co</a> ("Service").
        Please read this policy carefully to understand our practices regarding
        your personal information.
      </p>
      <nz-divider></nz-divider>
      <h2
        i18n="
          @@page-privacy-policy-content-information-we-collect-section-title"
        nz-typography>
        Information We Collect
      </h2>
      <ul>
        <li>
          <p
            i18n="
              @@page-privacy-policy-content-information-we-collect-section-paragraph-0"
            nz-typography>
            We do not collect any personal information such as your name, email
            address, or phone number when you use our Service.
          </p>
        </li>
        <li>
          <p
            i18n="
              @@page-privacy-policy-content-information-we-collect-section-paragraph-1"
            nz-typography>
            We may collect non-personal information such as your IP address,
            browser type, device type, and operating system for analytical
            purposes.
          </p>
        </li>
      </ul>
      <nz-divider></nz-divider>
      <h2
        i18n="@@page-privacy-policy-content-use-of-cookies-section-title"
        nz-typography>
        Use of Cookies
      </h2>
      <ul>
        <li>
          <p
            i18n="
              @@page-privacy-policy-content-use-of-cookies-section-paragraph-0"
            nz-typography>
            We use cookies to enhance your experience on our Service. Cookies
            are small files stored on your device that allow us to recognize you
            and remember your preferences.
          </p>
        </li>
        <li>
          <p
            i18n="
              @@page-privacy-policy-content-use-of-cookies-section-paragraph-1"
            nz-typography>
            You can manage cookies through your browser settings and choose to
            accept or decline them. Please note that disabling cookies may
            affect your experience on our Service.
          </p>
        </li>
        <li>
          <p
            i18n="
              @@page-privacy-policy-content-use-of-cookies-section-paragraph-2"
            nz-typography>
            For more information about how we use cookies, please review our
            <a [routerLink]="'/cookie-policy'">Cookie Policy</a>.
          </p>
        </li>
      </ul>
      <nz-divider></nz-divider>
      <h2
        i18n="@@page-privacy-policy-content-google-analytics-section-title"
        nz-typography>
        Google Analytics
      </h2>
      <ul>
        <li>
          <p
            i18n="
              @@page-privacy-policy-content-google-analytics-section-paragraph-0"
            nz-typography>
            We use Google Analytics, a web analytics service provided by Google,
            Inc. ("Google"), to analyze how users interact with our Service.
          </p>
        </li>
        <li>
          <p
            i18n="
              @@page-privacy-policy-content-google-analytics-section-paragraph-1"
            nz-typography>
            Google Analytics uses cookies to collect information about your
            usage of the Service. This information is used to generate
            statistical reports and improve our Service.
          </p>
        </li>
      </ul>
      <nz-divider></nz-divider>
      <h2
        i18n="@@page-privacy-policy-content-google-adsense-section-title"
        nz-typography>
        Google AdSense
      </h2>
      <ul>
        <li>
          <p
            i18n="
              @@page-privacy-policy-content-google-adsense-section-paragraph-0"
            nz-typography>
            We may use Google AdSense to display personalized advertisements on
            our Service. Google AdSense uses cookies to serve ads based on your
            interests and browsing behavior.
          </p>
        </li>
        <li>
          <p
            i18n="
              @@page-privacy-policy-content-google-adsense-section-paragraph-1"
            nz-typography>
            You can opt out of personalized advertising by visiting Google's Ad
            Settings or using the Network Advertising Initiative's opt-out page.
          </p>
        </li>
      </ul>
      <nz-divider></nz-divider>
      <h2
        i18n="@@page-privacy-policy-content-data-security-section-title"
        nz-typography>
        Data Security
      </h2>
      <ul>
        <li>
          <p
            i18n="
              @@page-privacy-policy-content-data-security-section-paragraph-0"
            nz-typography>
            We take reasonable measures to protect your information from
            unauthorized access, disclosure, alteration, or destruction.
          </p>
        </li>
        <li>
          <p
            i18n="
              @@page-privacy-policy-content-data-security-section-paragraph-1"
            nz-typography>
            However, please note that no method of transmission over the
            internet or electronic storage is 100% secure. While we strive to
            protect your information, we cannot guarantee its absolute security.
          </p>
        </li>
      </ul>
      <nz-divider></nz-divider>
      <h2
        i18n="@@page-privacy-policy-content-third-party-links-section-title"
        nz-typography>
        Third-Party Links
      </h2>
      <ul>
        <li>
          <p
            i18n="
              @@page-privacy-policy-content-third-party-links-section-paragraph-0"
            nz-typography>
            Our Service may contain links to third-party websites or services
            that are not operated by us. We are not responsible for the privacy
            practices or content of these third-party sites.
          </p>
        </li>
        <li>
          <p
            i18n="
              @@page-privacy-policy-content-third-party-links-section-paragraph-1"
            nz-typography>
            We encourage you to review the privacy policies of any third-party
            sites you visit.
          </p>
        </li>
      </ul>
      <nz-divider></nz-divider>
      <h2
        i18n="@@page-privacy-policy-content-childrens-privacy-section-title"
        nz-typography>
        Children's Privacy
      </h2>
      <ul>
        <li>
          <p
            i18n="
              @@page-privacy-policy-content-childrens-privacy-section-paragraph-0"
            nz-typography>
            Our Service is not directed to children under the age of 13. We do
            not knowingly collect personal information from children. If you are
            a parent or guardian and believe that your child has provided us
            with personal information, please contact us.
          </p>
        </li>
      </ul>
      <nz-divider></nz-divider>
      <h2
        i18n="
          @@page-privacy-policy-content-changes-to-this-policy-section-title"
        nz-typography>
        Changes to This Policy
      </h2>
      <ul>
        <li>
          <p
            i18n="
              @@page-privacy-policy-content-changes-to-this-policy-section-paragraph-0"
            nz-typography>
            We may update this Privacy Policy from time to time. Any changes
            will be posted on this page with a revised effective date.
          </p>
        </li>
        <li>
          <p
            i18n="
              @@page-privacy-policy-content-changes-to-this-policy-section-paragraph-1"
            nz-typography>
            Your continued use of the Service after the changes are made
            constitutes your acceptance of the updated Privacy Policy.
          </p>
        </li>
      </ul>
      <nz-divider></nz-divider>
      <h2
        i18n="@@page-privacy-policy-content-contact-us-section-title"
        nz-typography>
        Contact Us
      </h2>
      <ul>
        <li>
          <p
            i18n="@@page-privacy-policy-content-contact-us-section-paragraph-0"
            nz-typography>
            If you have any questions or concerns about this Privacy Policy or
            our practices, please contact us at
            <strong>hello&#64;ig4u.co</strong>.
          </p>
        </li>
      </ul>
      <p i18n="@@page-privacy-policy-content-paragraph-2" nz-typography>
        By using our Service, you agree to the terms outlined in this Privacy
        Policy. Thank you for trusting Ig4u with your privacy.
      </p>
    </article>
  </nz-col>
</nz-row>
